import { Pipe, PipeTransform } from '@angular/core';
import {
    RaceAdditionalPricingItem, RaceCommercialItem,
    RaceRegistrationResultDto,
    RegisterToRaceFormType,
    WspayConfirmation
} from '@model';
import {
    discountAmount,
    hasAnyPrice,
    subTotalAmount,
    totalAmount,
    totalAmountWithoutFee,
    traceyFeeAmount
} from "@utility";

@Pipe({
    name: 'totalAmount',
    standalone: false
})
export class TotalAmountPipe implements PipeTransform {
    transform(formType: RegisterToRaceFormType, calculationResponse?: RaceRegistrationResultDto,
              registerToRaceResponse?: RaceRegistrationResultDto,
              wspayConfirmation?: WspayConfirmation
    ): number {
        return totalAmount(formType, calculationResponse, registerToRaceResponse, wspayConfirmation);
    }

}

@Pipe({
    name: 'subTotalAmount',
    standalone: false
})
export class SubTotalAmountPipe implements PipeTransform {

    transform(
        formType: RegisterToRaceFormType,
        calculationResponse?: RaceRegistrationResultDto,
        registerToRaceResponse?: RaceRegistrationResultDto,
        wspayConfirmation?: WspayConfirmation
    ): number {
        return subTotalAmount(formType, calculationResponse, registerToRaceResponse, wspayConfirmation);
    }
}

@Pipe({
    name: 'totalAmountWithoutFee',
    standalone: false
})
export class TotalAmountWithoutFee implements PipeTransform {

    transform(
        formType: RegisterToRaceFormType,
        calculationResponse?: RaceRegistrationResultDto,
        registerToRaceResponse?: RaceRegistrationResultDto,
        wspayConfirmation?: WspayConfirmation
    ): number {
        return totalAmountWithoutFee(formType, calculationResponse, registerToRaceResponse, wspayConfirmation);

    }
}

@Pipe({
    name: 'traceyFeeAmount',
    standalone: false
})
export class TraceyFeeAmount implements PipeTransform {

    transform(
        formType: RegisterToRaceFormType,
        calculationResponse?: RaceRegistrationResultDto,
        registerToRaceResponse?: RaceRegistrationResultDto,
        wspayConfirmation?: WspayConfirmation
    ): number {
        return traceyFeeAmount(formType, calculationResponse, registerToRaceResponse, wspayConfirmation);
    }
}

@Pipe({
    name: 'discountAmount',
    standalone: false
})
export class DiscountAmountPipe implements PipeTransform {

    transform(
        formType: RegisterToRaceFormType,
        calculationResponse?: RaceRegistrationResultDto,
        registerToRaceResponse?: RaceRegistrationResultDto,
        wspayConfirmation?: WspayConfirmation
    ): number {
        return discountAmount(formType, calculationResponse, registerToRaceResponse, wspayConfirmation);
    }
}


@Pipe({
    name: 'hasAnyPrice',
    standalone: false
})
export class HasAnyPricePipe implements PipeTransform {
    transform(
        raceCommercialItem: RaceCommercialItem | RaceCommercialItem[] | undefined,
        additionalPricingItems: RaceAdditionalPricingItem[] | undefined
    ): boolean {
        return hasAnyPrice(raceCommercialItem, additionalPricingItems);
    }
}
